import AbstractEntity from "../AbstractEntity";

export default class QuotationItem extends AbstractEntity {
    _id;
    _name;
    _pricing;
    _quantity;
    _validationHash;
    _createdAt;
    _quotationId;


    getId() {
        return this._id;
    }

    getName() {
        return this._name;
    }

    getPricing() {
        return this._pricing;
    }

    getQuantity() {
        return this._quantity;
    }

    getValidationHash() {
        return this._validationHash;
    }

    getCreatedAt() {
        return this._createdAt;
    }

    getQuotationId() {
        return this._quotationId;
    }

    getClassName() {
        return "quotation_item";
    }
}
